import {
    Source,
} from 'one-model';

import {
    Action,
} from 'one-state';

import {
    ADD,
    SET,
    RESET,
    REMOVE,
    SELECT,
    UNSELECT,
} from './types';

/**
 * Redux action creator to add a source
 * to the list of sources
 * @param source source to be added
 * @returns action instance
 */
export const addAction = (source: Source):
    Action<typeof ADD, Source> => ({
        type: ADD,
        payload: source,
    });

/**
 * Redux action creator to remove a source
 * from the list of sources
 * @param key source identifier 
 * to be removed from the list
 * @returns action instance
 */
export const removeAction = (key: string):
    Action<typeof REMOVE, string> => ({
        type: REMOVE,
        payload: key,
    });

/**
 * Redux action creator to set the list
 * of sources
 * @param sources list of sources
 * @returns action instance
 */
export const setAction = (sources: Source[]):
    Action<typeof SET, Source[]> => ({
        type: SET,
        payload: sources,
    });

/**
 * Redux action creator to set select a 
 * source from the list
 * @param key source identifier
 * @returns action instance
 */
export const selectAction = (key: string):
    Action<typeof SELECT, string> => ({
        type: SELECT,
        payload: key,
    });

/**
 * Redux action creator to unselect the source
 * @returns action instance 
 */
export const unselectAction = ():
    Action<typeof UNSELECT> => ({
        type: UNSELECT,
    });

/**
 * Reset the state
 * @returns action instance 
 */
export const resetAction = ():
    Action<typeof RESET> => ({
        type: RESET,
    });

/**
 * List of all valid actions
 */
export type Actions =
    ReturnType<typeof addAction> |
    ReturnType<typeof setAction> |
    ReturnType<typeof resetAction> |
    ReturnType<typeof removeAction> |
    ReturnType<typeof selectAction> |
    ReturnType<typeof unselectAction>;
